export function parseViewerParameters(href: string, search: string, frameQuery?: string): URLSearchParams {
  return new URLSearchParams(href.split('#')[0] === 'about:srcdoc' ? frameQuery ?? '' : search);
}

export function viewerParameters(): URLSearchParams {
  let frameQuery: string | undefined;
  if (location.href.split('#')[0] === 'about:srcdoc') {
    try { frameQuery = (window.frameElement as HTMLElement | null)?.dataset.viewerQuery; }
    catch { /* A sandboxed or inaccessible frame cannot supply viewer parameters. */ }
  }
  return parseViewerParameters(location.href, location.search, frameQuery);
}
